// extracted by mini-css-extract-plugin
module.exports = {"content":"GetStartedPage_content__2krJK","embedded":"GetStartedPage_embedded__3e0x-"};